<template lang="pug">
.modal.is-active.is-clipped(@click="$emit('close')")
  .modal-background
  .modal-card(@keydown.esc="$emit('close')", tabindex="0", :id="id")
    .modal-card-body(@click.stop="")
      .columns.upper-modal
        .column
          span First be sure to install our Monitoring App
          i.fa.fa-mobile
        .column.has-text-left
          a.get-app-image.android(href="https://play.google.com/store/apps/details?id=com.unmineable.mobileapp", target="_blank")
            img(src="/img/app-store-badge-android.png")
          a.get-app-image(href="https://apps.apple.com/pe/app/unmineable/id6444838563", target="_blank") 
            img(src="/img/app-store-badge.svg")

      .middle-modal
        div.description.has-text-centered
          span Scan this QR in the Address option:          
        .qr-container.has-text-centered
          div.is-loading(v-show="isLoading")
            i.fa.fa-qrcode.fa-fade
          canvas#qrcanva(v-show="!isLoading")
      .down-modal
        p.big-info.main.mb-10.fs-16.has-text-centered
          span.text-white-on-dark ...or 
          span.fw-400 Copy &amp; Paste 
          span your address manually

        p.mb-20.address-container.has-text-centered
          b.wb-ba.text-white-on-dark.fw-400.fs-15.address-field {{ address }}
          b.wb-ba.text-white-on-dark.fw-600.fs-15.address-field(v-if="memo") :{{ memo }}
  .modal-close(@click="$emit('close')")
</template>

<script>
import { nanoid } from 'nanoid'
let QRCode = require('qrcode')
export default {
  name: 'c_generate_qr',
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    id() {
      return 'qr-modal-' + nanoid(10)
    },
    mode() {
      return this.$store.getters.mode
    }
  },
  watch: {
    mode() {
      let vm = this
      vm.createQR(function (error) {
        if (error) console.error('Error generating QR:', error.message)
      })
    }
  },
  props: ['address', 'memo'],
  mounted() {
    let vm = this
    vm.isLoading = true
    vm.createQR(function (error) {
      if (error) console.error('Error generating QR:', error.message)
      vm.isLoading = false
    })
    document.getElementById(vm.id).focus();
  },
  methods: {
    createQR(cb) {
      let vm = this
      let canvas = document.getElementById('qrcanva')
      QRCode.toCanvas(canvas, vm.address + (vm.memo ? (':' + vm.memo) : ''), {
        width: 200,
        errorCorrectionLevel: 'H',
        color: {
          dark: vm.mode === 'dark' ? '#fff' : '#000',
          light: '#0000'
        }
      }, function (error) {
        cb(error)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

.modal
  z-index: 1000002;
.address-field
  font-family: 'Azeret Mono', monospace;
.upper-modal
  padding 10px
  margin: 10px;
  margin-bottom: 5px;
  margin-top: 5px;
  border: solid #ccc 1px;
  border-radius: 10px;
  text-align right
  padding-bottom 0px
  span
    font-weight 700
  i
    vertical-align middle
    margin-left 5px
    margin-top -2px
    font-size 20px
    font-weight 700
    color #4a4a4a

.middle-modal
  margin-top 10px
  .qr-container
    position relative
    margin-bottom -5px
  .is-loading
    padding-top 8px
  i
    font-size 200px
    color #A4A4A4
    padding-bottom 0px
  .description
    font-size 16px
    font-weight 400
    word-wrap break-word

.down-modal
  width 100%
  .address-container
    width 100%
    padding: 15px;
    font-weight: 700;
    border: 2px dashed #efefef;
    font-size: 18px;
    word-break: break-word;

.modal-close
  &::before
    width 15px
  &::after
    height 15px
.modal-background
  background-color rgba(10,10,10,.6)
  cursor: pointer
.modal-card-body
  border-radius 7.5px

.modal-card
  outline none

.get-app-image
  flex 1
  padding 5px 5px
  &.android
    img
      height 40px
    
html.dark
  i
    color #969696
  .modal-card-body
    background-color #2c2c2c
  .description
    color #fff
  .upper-modal
    color #fff
    i
      color #fff

@media (max-width: 768px)
  .modal-card
    padding-left 20px
    padding-right 20px
  .upper-modal
    display flex
    flex-direction column
    align-items center
    text-align left
    .column
      padding 5px
    

@media (max-width: 450px)
  .modal-card
    margin-top 30px
</style>



// WEBPACK FOOTER //
// c_generate_qr.vue?36342d0a